import i18n from "i18n/config";
import { formatDateDisplay } from "shared/components/input/date/DateInputUtils";
import { z } from "zod";

const { t } = i18n;

const customErrorMap: z.ZodErrorMap = (issue, ctx) => {
  const message = ((): string => {
    if (issue.code === "invalid_type") {
      if (!ctx.data) {
        return t("errors:required");
      }
      return t("errors:notType", { type: issue.expected });
    } else if (issue.code === "invalid_string") {
      if (!ctx.data) {
        return t("errors:required");
      }
      return t("errors:stringMatches");
    } else if (issue.code === "invalid_enum_value") {
      if (!issue.received) {
        return t("errors:required");
      }
      return t("errors:invalid");
    } else if (
      issue.code === "invalid_date" ||
      issue.code === "unrecognized_keys"
    ) {
      return t("errors:invalid");
    } else if (issue.code === "too_small") {
      if (issue.type === "string") {
        return issue.minimum === 1
          ? t("errors:required")
          : t("errors:stringMin", { min: issue.minimum });
      } else if (issue.type === "array") {
        return t("errors:arrayMin", { count: Number(issue.minimum) });
      } else if (issue.type === "date") {
        return t("errors:dateMin", {
          min: formatDateDisplay(new Date(Number(issue.minimum))),
        });
      } else if (issue.type === "number") {
        return issue.minimum === 0
          ? t("errors:numberPos")
          : t("errors:numberMin", { min: issue.minimum });
      }
    } else if (issue.code === "too_big") {
      if (issue.type === "string") {
        return t("errors:stringMax", { max: issue.maximum });
      } else if (issue.type === "array") {
        return t("errors:arrayMax", { count: Number(issue.maximum) });
      } else if (issue.type === "date") {
        return t("errors:dateMax", {
          max: formatDateDisplay(new Date(Number(issue.maximum))),
        });
      } else if (issue.type === "number") {
        return issue.maximum === 0
          ? t("errors:numberNeg")
          : t("errors:numberMax", { max: issue.maximum });
      }
    }
    return ctx.defaultError;
  })();
  return { message };
};

export const appInitZod = () => {
  z.setErrorMap(customErrorMap);
};
